import { MdOutlinePersonOutline, MdLocationPin } from "react-icons/md";
import { FaPhone, FaConciergeBell } from "react-icons/fa";

import { useState } from "react";
import { Modal } from "../pop-up/pop-up";

import "./navbar.css";

export const TopBar = () => {
  const url = "https://forms.gle/VJvfiXFi5HkuWoeLA";
  const [showModal, setShowModal] = useState(false);
  return (
    <div className="flex justify-between h-[50px] border-b border-inherit text-[15px] ">
      <div className="hidden md:flex justify-start ml-10">
        {/* phone */}
        <div className="flex items-center justify-start w-[200px]">
          <div className="flex items-center justify-center rounded-full bg-golden w-8 h-8 mr-2 ">
            <FaPhone className=" text-white text-[20px]"></FaPhone>
          </div>
          <p>+977-981973006</p>
        </div>

        <div className="flex items-center justify-start w-[300px]">
          <div className="flex items-center justify-center rounded-full bg-golden w-8 h-8 mr-2 ">
            <MdLocationPin className=" text-white text-[20px]"></MdLocationPin>
          </div>
          <p>28th Street, Lakeside, Pokhara</p>
        </div>
        {/* location */}
      </div>

      <div className="flex md:justify-end w-[100vh] border-inherit md:mr-10">
        {/*Account*/}
        <button
          id="myaccount-btn"
          className="flex items-center justify-center w-1/2 h-[50px] border-l border-inherit md:w-[200px]"
          onClick={() => {
            setShowModal(!showModal);
          }}
        >
          <MdOutlinePersonOutline className=" text-2xl mr-2"></MdOutlinePersonOutline>
          <p className="text-[15px] ">My Account</p>

          {showModal && (
            <Modal
              showModal={showModal}
              setShowModal={() => setShowModal(!showModal)}
            />
          )}
        </button>

        {/*Book Now*/}
        <button
          id="booknow-btn"
          className="bg-golden flex items-center justify-center w-1/2 h-[50px] text-white font-bold md:w-[150px]"
          onClick={() => {
            window.open(url, "_blank");
          }}
        >
          <FaConciergeBell className=" text-[18px] mr-2"></FaConciergeBell>
          <p className="">Book Now</p>
        </button>
      </div>
    </div>
  );
};

export const BottomBar = () => {
  return (
    <div className="">
      <div className="flex h-[80px]  items-center justify-between mx-5 md:mx-10">
        <div className="hidden space-x-10 md:flex md:basis-1/3 justify-start">
          <a href="#image-slider" className="hover:text-darkGrayishBlue">
            Home
          </a>
          <a href="#rooms" className="hover:text-darkGrayishBlue">
            Rooms
          </a>
          <a href="#services" className="hover:text-darkGrayishBlue">
            Services
          </a>
        </div>
        <div className="flex md:basis-1/3 md:justify-center">
          <a
            href="#image-slider"
            className="text-[25px] md:text-[35px] font-[400] tracking-wide"
          >
            Country Yard
          </a>
        </div>
        <div className="hidden space-x-10 md:flex md:basis-1/3 justify-end">
          <a href="#gallery" className="hover:text-darkGrayishBlue">
            Gallery
          </a>
          <a href="#rooms" className="hover:text-darkGrayishBlue">
            About Us
          </a>
          <a href="#contactus" className="hover:text-darkGrayishBlue">
            Contacts Us
          </a>
        </div>
        <button
          id="menu-btn"
          className="block hamburger md:hidden focus:outline-none"
          onClick={() => {
            const btn = document.getElementById("menu-btn");
            const nav = document.getElementById("menu");
            btn.classList.toggle("open");
            nav.classList.toggle("flex");
            nav.classList.toggle("hidden");
          }}
        >
          <span className="hamburger-top"></span>
          <span className="hamburger-middle"></span>
          <span className="hamburger-bottom"></span>
        </button>
      </div>

      <div className="md:hidden">
        <div
          id="menu"
          className="absolute flex-col items-center self-end hidden py-8 mt-10 space-y-6 font-bold bg-white sm:w-auto sm:self-center left-6 right-6 drop-shadow-md z-[2]"
        >
          <a href="#image-slider" className="hover:text-brightRed">
            Home
          </a>
          <a href="#rooms" className="hover:text-brightRed">
            Rooms
          </a>
          <a href="#services" className="hover:text-brightRed">
            Services
          </a>
          <a href="#gallery" className="hover:text-brightRed">
            Gallery
          </a>
          <a href="#about" className="hover:text-brightRed">
            About Us
          </a>
          <a href="#contactus" className="hover:text-brightRed">
            Contact Us
          </a>
        </div>
      </div>
    </div>
  );
};

export const NavBar = () => {
  return (
    <nav className="md:absolute md:left-0 md:top-0  md:z-[1] w-[100%] bg-white md:bg-transparent md:hover:bg-white md:text-white md:hover:text-black border-black/25 md:border-white/25 md:hover:border-black/25 md:border-l-white/25 md:hover:border-l-black/25">
      <TopBar />
      <BottomBar />
    </nav>
  );
};
